/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_customblocks_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코스에서 사용할 수 있는 커스텀 블록들에 대한 설명`)
};

const en_course_customblocks_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description of custom blocks available for courses`)
};

const ja_course_customblocks_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースで利用可能なカスタムブロックの説明`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_customblocks_description1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_customblocks_description1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_customblocks_description1", locale)
	if (locale === "ko") return ko_course_customblocks_description1(inputs)
	if (locale === "en") return en_course_customblocks_description1(inputs)
	return ja_course_customblocks_description1(inputs)
};
export { course_customblocks_description1 as "course_customBlocks_description" }